var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import * as Const from "@utils/Const";
import * as cutil from "@utils/Cutil";
import { useAsync } from "react-async";
import { PromiseHttp } from "@utils/api/HttpUtil";
export default function BoardUpdate(props) {
    var _a, _b, _c;
    const { item, setItem, } = props;
    let token = localStorage.getItem(Const.TOKEN);
    let lang = localStorage.getItem(Const.LANG_TYPEA);
    const [items, setItems] = useState(null);
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [isBlind, setIsBlind] = useState(true);
    const [file, setFile] = useState([]);
    const [reTitle, setReTitle] = useState("");
    const [reContent, setReContent] = useState("");
    const [repFile, setRepFile] = useState([]);
    const [reset, setRest] = useState(false);
    // API
    const { data: data } = useAsync({
        promiseFn: PromiseHttp,
        httpMethod: Const.API_POST,
        appPath: `/admin/board/post/${item.postId}`,
        appQuery: {},
        userToken: token,
        watch: item.postId + reset,
    });
    useEffect(() => {
        var _a, _b, _c, _d;
        if (data) {
            if (data.codeNum == Const.API_200) {
                setItems(data.body);
                setTitle(data.body.title);
                setContent(data.body.content);
                setIsBlind(data.body.blind);
                setFile(data.body.attachList);
                setReTitle((_a = data.body.replyList[0]) === null || _a === void 0 ? void 0 : _a.title);
                setReContent((_b = data.body.replyList[0]) === null || _b === void 0 ? void 0 : _b.content);
                setRepFile(((_c = data.body.replyList[0]) === null || _c === void 0 ? void 0 : _c.fileList) ? (_d = data.body.replyList[0]) === null || _d === void 0 ? void 0 : _d.fileList : []);
                setRest(false);
            }
            else {
                alert(data.body.message);
            }
        }
    }, [data]);
    const handleUpload = (e) => {
        const input = document.createElement("input");
        input.type = "file";
        input.multiple = false; // 하나만 업로드
        // 필요시 허용 확장자 지정: input.accept = "*/*";
        input.onchange = (ev) => {
            var _a;
            const target = ev.currentTarget;
            const f = (_a = target.files) === null || _a === void 0 ? void 0 : _a[0];
            if (!f)
                return;
            handleSelectFile(f);
        };
        input.click();
    };
    // 첨부파일 처리 (단일 파일)
    const handleSelectFile = (f) => {
        // 이미 1개가 있으면 추가 업로드 불가 (교체를 원하면 setFile([newItem])만 호출하고 return 제거)
        if (file.length >= 1 && item.depth2.url == Const.URL_NOTICE) {
            alert("하나만 업로드 가능합니다.");
            return;
        }
        else if (repFile.length >= 1 && item.depth2.url == Const.URL_CONTACT) {
            alert("하나만 업로드 가능합니다.");
            return;
        }
        // 단일 파일만 허용
        if (item.depth2.url == Const.URL_NOTICE) {
            setFile([...file, f]);
        }
        else if (item.depth2.url == Const.URL_CONTACT) {
            setRepFile([...repFile, f]);
        }
    };
    const handleView = () => {
        setItem((prev) => (Object.assign(Object.assign({}, prev), { type: "" })));
    };
    // 답글 수정
    const replyUpdate = (e) => __awaiter(this, void 0, void 0, function* () {
        var _d;
        var isOk = confirm(`수정하시겠습니까?`);
        if (!isOk)
            return;
        let data = null;
        data = yield PromiseHttp({
            httpMethod: Const.API_PUT,
            appPath: `/admin/board/post/reply/${(_d = items.replyList[0]) === null || _d === void 0 ? void 0 : _d.replyId}`,
            appQuery: {
                title: reContent,
                content: reContent,
                isBlind: isBlind,
                writer: lang == Const.LANG_KOR ? "관리자" : "Admin",
            },
            userToken: token,
        });
        if (data) {
            if (data.codeNum == Const.API_200) {
                if (repFile.filter((val) => (!val.fileId)).length > 0) {
                    refileAdd(data.body.replyId);
                }
                else {
                    alert("수정 되었습니다.");
                    location.reload();
                }
            }
            else {
                alert(data.body.message);
            }
        }
    });
    // 게시판 수정
    const boardUpdate = (e) => __awaiter(this, void 0, void 0, function* () {
        var isOk = confirm(`수정하시겠습니까?`);
        if (!isOk)
            return;
        let data = null;
        data = yield PromiseHttp({
            httpMethod: Const.API_PUT,
            appPath: `/admin/board/post/${items.postId}`,
            appQuery: {
                title: title,
                content: content,
                isBlind: isBlind,
                writer: lang == Const.LANG_KOR ? "관리자" : "Admin",
            },
            userToken: token,
        });
        if (data) {
            if (data.codeNum == Const.API_200) {
                if (file.filter((val) => (!val.fileId)).length > 0 && item.depth2.url != Const.URL_FAQ) {
                    fileAdd(data.body.postId);
                }
                else {
                    alert("수정 되었습니다.");
                    location.reload();
                }
            }
            else {
                alert(data.body.message);
            }
        }
    });
    // 첨부파일 업로드 (단일 파일)
    const fileAdd = (postId) => __awaiter(this, void 0, void 0, function* () {
        var _e, _f;
        const formData = new FormData();
        file.map((files) => formData.append("files", files));
        let data = null;
        data = yield PromiseHttp({
            httpMethod: Const.API_POSTF,
            appPath: `/admin/file/post/${postId}`,
            appQuery: formData,
            userToken: token,
        });
        if (data) {
            if (data.codeNum == Const.API_200) {
                alert(`수정 되었습니다.`);
                location.reload();
            }
            else {
                alert((_f = (_e = data.body) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : "파일 업로드 실패");
            }
        }
    });
    const refileAdd = (replyId) => __awaiter(this, void 0, void 0, function* () {
        var _g, _h;
        const formData = new FormData();
        repFile.map((files) => formData.append("files", files));
        let data = null;
        data = yield PromiseHttp({
            httpMethod: Const.API_POSTF,
            appPath: `/admin/file/reply/${replyId}`,
            appQuery: formData,
            userToken: token,
        });
        if (data) {
            if (data.codeNum == Const.API_200) {
                alert(`수정 되었습니다.`);
                location.reload();
            }
            else {
                alert((_h = (_g = data.body) === null || _g === void 0 ? void 0 : _g.message) !== null && _h !== void 0 ? _h : "파일 업로드 실패");
            }
        }
    });
    //이미지 삭제
    const handleImaDel = (e, fileId) => __awaiter(this, void 0, void 0, function* () {
        if (fileId) {
            var isOk = confirm(`해당 파일을 삭제하시겠습니까?`);
            if (!isOk)
                return;
            let data = null;
            data = yield PromiseHttp({
                httpMethod: Const.API_DELETE,
                appPath: `/admin/file/${fileId}`,
                appQuery: {},
                userToken: token,
            });
            if (data) {
                if (data.codeNum == Const.API_200) {
                    alert("삭제되었습니다.");
                    setRest(true);
                }
                else {
                    alert(data.body.message);
                }
            }
        }
        else {
            setFile([]);
        }
    });
    return (_jsx(_Fragment, { children: _jsxs("section", Object.assign({ className: "board-main" }, { children: [_jsx("div", Object.assign({ className: "board-header" }, { children: _jsxs("h4", { children: ["\uAC8C\uC2DC\uD310 \uAD6C\uBD84: ", item.depth2.menuName] }) })), ((_a = item.depth2) === null || _a === void 0 ? void 0 : _a.url) === Const.URL_NOTICE && items &&
                    _jsx(Notice, { title: title, setTitle: setTitle, content: content, setContent: setContent, isBlind: isBlind, setIsBlind: setIsBlind, file: file, setFile: setFile, handleView: handleView, handleUpload: handleUpload, boardUpdate: boardUpdate, handleImaDel: handleImaDel }), ((_b = item.depth2) === null || _b === void 0 ? void 0 : _b.url) === Const.URL_CONTACT && items &&
                    _jsx(Contact, { items: items, reTitle: reTitle, setReTitle: setReTitle, reContent: reContent, setReContent: setReContent, isBlind: isBlind, setIsBlind: setIsBlind, repFile: repFile, setFile: setFile, handleView: handleView, handleUpload: handleUpload, replyUpdate: replyUpdate, handleImaDel: handleImaDel }), ((_c = item.depth2) === null || _c === void 0 ? void 0 : _c.url) === Const.URL_FAQ && items &&
                    _jsx(Faq, { title: title, setTitle: setTitle, content: content, setContent: setContent, isBlind: isBlind, setIsBlind: setIsBlind, handleView: handleView, handleUpload: handleUpload, boardUpdate: boardUpdate })] })) }));
}
;
function Notice(props) {
    var _a, _b;
    const { items, title, setTitle, content, setContent, isBlind, setIsBlind, file, setFile, handleView, handleUpload, boardUpdate, handleImaDel, } = props;
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "board-section" }, { children: [_jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "\uC81C\uBAA9" }), _jsx("input", { type: "text", value: title, onChange: (e) => setTitle(e.target.value) })] })), _jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "\uCCA8\uBD80\uD30C\uC77C" }), ((_a = file[0]) === null || _a === void 0 ? void 0 : _a.fileId) ? file.map((val) => (_jsxs("div", Object.assign({ className: "file-item" }, { children: [_jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 12 12", fill: "none" }, { children: [_jsx("g", Object.assign({ clipPath: "url(#clip0_534_749)" }, { children: _jsx("path", { d: "M4.71671 11.1121C6.77744 9.06278 8.3894 7.42464 10.1824 5.66612C10.7744 5.04786 11.1493 4.44275 11.3071 3.8508C11.5834 2.73373 11.1586 1.7664 10.4192 1.00943C9.70885 0.299086 8.94917 -0.0363506 8.14017 0.00311604C6.92667 0.062316 6.53205 0.450376 5.74277 1.22649L0.711163 6.2778L1.5399 7.08679L6.5715 2.05521C7.0878 1.56434 7.7022 1.10156 8.40655 1.16728C9.47972 1.31794 10.4275 2.63144 10.1824 3.55482C9.87171 4.37406 9.44337 4.74771 8.85053 5.34053C7.04712 7.13933 5.64097 8.53036 3.888 10.2833C3.2292 10.8853 2.80314 11.0483 2.19108 10.4806C1.87538 10.1649 1.73725 9.85579 1.77671 9.55325C1.8205 9.20024 2.02034 8.95608 2.25026 8.72452L6.84774 4.12702C7.05777 3.91662 7.5361 3.51277 7.73567 3.69293C7.88878 4.04814 7.49447 4.38718 7.30159 4.58086L3.07899 8.80345L3.88798 9.63219L8.1303 5.40961C8.86099 4.65596 9.38596 3.73501 8.56439 2.88395C7.65577 2.10407 6.69856 2.62472 6.019 3.29832L1.42152 7.8958C0.947963 8.36935 0.678299 8.88238 0.612533 9.43488C0.560653 10.2094 0.909863 10.8312 1.38206 11.3094C1.82591 11.7508 2.30542 11.9953 2.90142 12C3.61798 11.9713 4.32254 11.4993 4.71671 11.1121Z", fill: "#0048ff" }) })), _jsx("defs", { children: _jsx("clipPath", Object.assign({ id: "clip0_534_749" }, { children: _jsx("rect", { width: "12", height: "12", fill: "white" }) })) })] })), _jsx("span", Object.assign({ className: "file-name" }, { children: val.originalFileName })), _jsx("button", Object.assign({ className: "remove-btn", type: "button", onClick: (e) => handleImaDel(e, val.fileId) }, { children: "\u2715" }))] }), val.feileId))) :
                            _jsxs(_Fragment, { children: [_jsx("input", { type: "text", disabled: true, value: (_b = file[0]) === null || _b === void 0 ? void 0 : _b.name }), _jsx("button", Object.assign({ className: "img-btn", onClick: (e) => handleUpload(e) }, { children: "\uD30C\uC77C \uC120\uD0DD" }))] })] })), _jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "\uB0B4\uC6A9" }), _jsx("textarea", { value: content, onChange: (e) => setContent(e.target.value) })] })), _jsxs("div", Object.assign({ className: "board-footer" }, { children: [_jsxs("label", Object.assign({ className: "checkbox" }, { children: [_jsx("input", { type: "checkbox", name: "active", checked: isBlind, onChange: (e) => setIsBlind(e.target.checked) }), " \uAC8C\uC2DC\uAE00 \uD65C\uC131\uD654"] })), _jsxs("div", Object.assign({ className: "btn-box" }, { children: [_jsx("button", Object.assign({ onClick: (e) => boardUpdate(e) }, { children: "\uC800\uC7A5" })), _jsx("button", Object.assign({ onClick: handleView }, { children: "\uCDE8\uC18C" }))] }))] }))] })) }));
}
;
function Contact(props) {
    const { items, reTitle, setReTitle, reContent, setReContent, isBlind, setIsBlind, repFile, setFile, handleView, handleUpload, replyUpdate, handleImaDel, } = props;
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "board-section" }, { children: [_jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "\uC791\uC131\uC790" }), _jsx("input", { type: "text", disabled: true, value: items.writer })] })), _jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "\uC81C\uBAA9" }), _jsx("input", { type: "text", disabled: true, value: items.title })] })), _jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "\uB0B4\uC6A9" }), _jsx("textarea", { disabled: true, value: items.content })] })), _jsxs("div", Object.assign({ className: "row-file" }, { children: [_jsx("label", { children: "\uCCA8\uBD80\uD30C\uC77C" }), items.attachList.map((file) => (_jsx("div", Object.assign({ className: "row-detail-file" }, { children: _jsx("div", Object.assign({ className: "notice-detail-file", onClick: (e) => cutil.handleDownload(e, file, file.originalFileName) }, { children: _jsxs("a", Object.assign({ href: "#" }, { children: [file.originalFileName, _jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" }, { children: _jsx("path", { d: "M12 15.577L8.461 12.039L9.169 11.319L11.5 13.65V5H12.5V13.65L14.83 11.32L15.539 12.039L12 15.577ZM6.616 19C6.15533 19 5.771 18.846 5.463 18.538C5.155 18.23 5.00067 17.8453 5 17.384V14.961H6V17.384C6 17.538 6.064 17.6793 6.192 17.808C6.32 17.9367 6.461 18.0007 6.615 18H17.385C17.5383 18 17.6793 17.936 17.808 17.808C17.9367 17.68 18.0007 17.5387 18 17.384V14.961H19V17.384C19 17.8447 18.846 18.229 18.538 18.537C18.23 18.845 17.8453 18.9993 17.384 19H6.616Z", fill: "#0048FF" }) }))] })) }), file.fileId) }))))] }))] })), items.replyList.map((val) => {
                var _a, _b;
                return (_jsxs("div", Object.assign({ className: "board-section" }, { children: [_jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "\uC81C\uBAA9" }), _jsx("input", { type: "text", value: reTitle, onChange: (e) => setReTitle(e.target.value) })] })), _jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "\uCCA8\uBD80\uD30C\uC77C" }), ((_a = repFile[0]) === null || _a === void 0 ? void 0 : _a.fileId) ? repFile.map((val) => (_jsxs("div", Object.assign({ className: "file-item" }, { children: [_jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 12 12", fill: "none" }, { children: [_jsx("g", Object.assign({ clipPath: "url(#clip0_534_749)" }, { children: _jsx("path", { d: "M4.71671 11.1121C6.77744 9.06278 8.3894 7.42464 10.1824 5.66612C10.7744 5.04786 11.1493 4.44275 11.3071 3.8508C11.5834 2.73373 11.1586 1.7664 10.4192 1.00943C9.70885 0.299086 8.94917 -0.0363506 8.14017 0.00311604C6.92667 0.062316 6.53205 0.450376 5.74277 1.22649L0.711163 6.2778L1.5399 7.08679L6.5715 2.05521C7.0878 1.56434 7.7022 1.10156 8.40655 1.16728C9.47972 1.31794 10.4275 2.63144 10.1824 3.55482C9.87171 4.37406 9.44337 4.74771 8.85053 5.34053C7.04712 7.13933 5.64097 8.53036 3.888 10.2833C3.2292 10.8853 2.80314 11.0483 2.19108 10.4806C1.87538 10.1649 1.73725 9.85579 1.77671 9.55325C1.8205 9.20024 2.02034 8.95608 2.25026 8.72452L6.84774 4.12702C7.05777 3.91662 7.5361 3.51277 7.73567 3.69293C7.88878 4.04814 7.49447 4.38718 7.30159 4.58086L3.07899 8.80345L3.88798 9.63219L8.1303 5.40961C8.86099 4.65596 9.38596 3.73501 8.56439 2.88395C7.65577 2.10407 6.69856 2.62472 6.019 3.29832L1.42152 7.8958C0.947963 8.36935 0.678299 8.88238 0.612533 9.43488C0.560653 10.2094 0.909863 10.8312 1.38206 11.3094C1.82591 11.7508 2.30542 11.9953 2.90142 12C3.61798 11.9713 4.32254 11.4993 4.71671 11.1121Z", fill: "#0048ff" }) })), _jsx("defs", { children: _jsx("clipPath", Object.assign({ id: "clip0_534_749" }, { children: _jsx("rect", { width: "12", height: "12", fill: "white" }) })) })] })), _jsx("span", Object.assign({ className: "file-name" }, { children: val.originalFileName })), _jsx("button", Object.assign({ className: "remove-btn", type: "button", onClick: (e) => handleImaDel(e, val.fileId) }, { children: "\u2715" }))] }), val.feileId))) :
                                    _jsxs(_Fragment, { children: [_jsx("input", { type: "text", disabled: true, value: (_b = repFile[0]) === null || _b === void 0 ? void 0 : _b.name }), _jsx("button", Object.assign({ className: "img-btn", onClick: (e) => handleUpload(e) }, { children: "\uD30C\uC77C \uC120\uD0DD" }))] })] })), _jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "\uB0B4\uC6A9" }), _jsx("textarea", { value: reContent, onChange: (e) => setReContent(e.target.value) })] })), _jsx("div", Object.assign({ className: "board-footer" }, { children: _jsxs("div", Object.assign({ className: "btn-box" }, { children: [_jsx("button", Object.assign({ onClick: (e) => replyUpdate(e) }, { children: "\uC800\uC7A5" })), _jsx("button", Object.assign({ onClick: handleView }, { children: "\uCDE8\uC18C" }))] })) }))] }), val.replyId));
            })] }));
}
function Faq(props) {
    const { title, setTitle, content, setContent, isBlind, setIsBlind, handleView, boardUpdate, } = props;
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "board-section" }, { children: [_jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "Q" }), _jsx("input", { type: "text", value: title, onChange: (e) => setTitle(e.target.value) })] })), _jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "A" }), _jsx("textarea", { value: content, onChange: (e) => setContent(e.target.value) })] })), _jsxs("div", Object.assign({ className: "board-footer" }, { children: [_jsxs("label", Object.assign({ className: "checkbox" }, { children: [_jsx("input", { type: "checkbox", name: "active", checked: isBlind, onChange: (e) => setIsBlind(e.target.checked) }), " \uAC8C\uC2DC\uAE00 \uD65C\uC131\uD654"] })), _jsxs("div", Object.assign({ className: "btn-box" }, { children: [_jsx("button", Object.assign({ onClick: (e) => boardUpdate(e) }, { children: "\uC800\uC7A5" })), _jsx("button", Object.assign({ onClick: handleView }, { children: "\uCDE8\uC18C" }))] }))] }))] })) }));
}
